import { useLocation } from "react-router-dom";
import EditHome from '../Components/EditPageComponents/EditHome';
import EditRetailers from '../Components/EditPageComponents/EditRetailers.js';
import EditContact from '../Components/EditPageComponents/EditContact.js'
import EditAbout from '../Components/EditPageComponents/EditAbout.js'
import EditProducts from '../Components/EditPageComponents/EditProducts.js'
import EditReferences from '../Components/EditPageComponents/EditReferences.js'
import EditExpertise from '../Components/EditPageComponents/EditExpertise.js'
import EditReports from '../Components/EditPageComponents/EditReports.js'
import EditTests from '../Components/EditPageComponents/EditTests.js'

import { Container, Row, Col, Table, Button, Form } from 'react-bootstrap';
import { useOutletContext } from 'react-router-dom';

const EditPage = () => {
    const { l } = useOutletContext();
    const location = useLocation();
    let page = location.state?.location;
    let section = location.state?.section;

    const pageMap = {
        contact: l('kontaktinformation', 'contact information'),
        retail: l('återförsäljare', 'retailers'),
        home: l('startsida', 'landing page'),
        about: 'information',
        products: l('produkter', 'products'),
        sheets: l("datablad", "sheets"),
        references: l('referenser', 'references'),
        reports: l('rapporter', 'reports'),
        tests: l('tester', 'tests'),
        ['rust-protection']: l('rostskydd', 'rust protection'),
        ['roof-painting']: l('takmålning', 'roof painting'),
        ['cultural-heritage']: l('kulturhistoriska objekt', 'cultural heritage objects'),
        expertise: l('verksamhetsområden', 'areas of expertise')
    };

    return (
        <>
            <Container style={{ border: "2px solid var(--newGray)", backgroundColor: "lightgray", borderRadius: "5px" }} className='p-3 mt-3'>
                <Row className="text-center">
                    <h2>{l(`Ändra ${pageMap[page]}`, `Change ${pageMap[page]}`)}</h2>
                </Row>
                {page === "home" && <EditHome />}
                {page === "retail" && <EditRetailers />}
                {page === "contact" && <EditContact />}
                {page === "about" && <EditAbout />}
                {["sheets", "products"].includes(page) && <EditProducts />}
                {page === "expertise" && <EditExpertise type={section || "expertise"} />}
                {page === "reports" && <EditReports />}
                {page === "tests" && <EditTests />}
                {page === "references" && <EditReferences />}
            </Container>
        </>
    );
};

export default EditPage;